<template>
    <div class="mt-15">
        <div v-if="bloqueo==0">
            <v-row>
                <v-col cols="12" class="mt-10 text-center">
                    <img src="@/assets/denegado.png" />
                </v-col>
            </v-row>
        </div>
        <div v-else-if="bloqueo==1">
            <v-container>
                <v-row class="mt-2">
                    <v-col cols="12" md="4">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <h5 class="mt-1">Tipo Atención</h5>
                                    </v-col>
                                    <v-col cols="12" md="6" class="text-end">
                                        <v-btn @click="open_atencion()" color="warning" x-small rounded dark>&nbsp;&nbsp;&nbsp;Modificar Atención&nbsp;&nbsp;&nbsp;</v-btn>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field v-if="btn_atencion!=true" type="number" label="N° Atención" class='text-body-2' v-model="comanda" dense outlined rounded></v-text-field>
                                        <v-text-field v-else type="number" label="N° Atención" class='text-body-2' v-model="comanda" dense outlined rounded filled readonly></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="date1" label="Fecha" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense outlined rounded></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="7" class="mt-n7">
                                        <v-select class='text-body-2' @change="change_tipo()"v-model="tipo" :items="myTipo" label="Tipo" dense outlined rounded></v-select>
                                    </v-col>
                                    <v-col cols="12" md="5" class="mt-n7">
                                        <v-text-field v-if="tipo=='Solarium'" type="number" label="N° Sesión" class='text-body-2' v-model="sesion" dense outlined rounded></v-text-field>
                                        <v-text-field v-else type="number" label="N° Sesión" class='text-body-2' v-model="sesion" dense outlined rounded disabled></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="5">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <h5 class="mt-1">Tipo Servicio</h5>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-10">    
                                    <v-col cols="12" md="6" class="mt-n7">
                                        <v-select @change="change_detail(servicio)" class='text-body-2' v-model="servicio" :items="myServicio" label="Servicio" item-text="descripcion" item-value="id" dense outlined rounded></v-select>
                                    </v-col>
                                    <v-col cols="12" md="6" class="mt-n7">
                                        <v-select @change="change_costo(detalle)" class='text-body-2' v-model="detalle" :items="myDetalle" label="Detalle" item-text="descripcion" item-value="descripcion" dense outlined rounded></v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12" class="mt-n7">
                                        <v-select class='text-body-2' v-model="profesional" :items="myProfesional" label="Profesional" dense outlined rounded></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" class="d-flex">
                                        <h5 class="mt-1">Costo Servicio</h5>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-10">
                                    <v-col cols="12" md="8" class="mt-n7">
                                        <v-text-field type="number" label="Costo Servicio" class='text-body-2' v-model="valor" dense outlined rounded></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="12" class="mt-n7">
                                        <v-select @change="change_comision(forma)" class='text-caption' v-model="forma" :items="myFormaPago" label="Forma de Pago" item-text="name" item-value="name" dense outlined rounded></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" class="d-flex">
                                        <h5 class="mt-1">Selecciona Cliente</h5>
                                        <v-btn @click="d_cliente=true" class="ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-10">
                                    <v-col cols="12" md="6" class="mt-n7">
                                        <v-text-field label="Rut" maxlength="10" class='text-body-2' v-model="rut" dense outlined rounded></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="10" class="mt-n7">
                                        <v-text-field label="Nombre" class='text-body-2' v-model="cliente" dense outlined rounded></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-sheet style="border:1px solid lightgray; background-color: lightgray;" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" class="d-flex">
                                        <v-btn @click="calcular_atencion()" class="mt-2" small color="teal" dark rounded>calcular atención</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-10">
                                    <v-col cols="6" md="6" class="mt-n6">
                                        <h4>TOTAL SERVICIO:</h4>
                                    </v-col>
                                    <v-col cols="6" md="6" class="mt-n6 text-end">
                                        <h4>${{ new Intl.NumberFormat("de-DE").format(parseFloat(total_servicio)) }}</h4>
                                    </v-col>
                                    <v-col cols="6" md="6" class="mt-n6">
                                        <h4>DCTO. TARJETA ({{comision}}%):</h4>
                                    </v-col>
                                    <v-col cols="6" md="6" class="mt-n6 text-end">
                                        <h4>${{ new Intl.NumberFormat("de-DE").format(parseFloat(desc_tarjeta)) }}</h4>
                                    </v-col>
                                    <v-col cols="6" md="6" class="mt-n6">
                                        <h4>SERVICIO 70%:</h4>
                                    </v-col>
                                    <v-col cols="6" md="6" class="mt-n6 text-end">
                                        <h4>${{ new Intl.NumberFormat("de-DE").format(parseFloat(ingreso_profesional)) }}</h4>
                                    </v-col>
                                    <v-col cols="6" md="6" class="mt-n6">
                                        <h4>INGRESO 30%:</h4>
                                    </v-col>
                                    <v-col cols="6" md="6" class="mt-n6 text-end">
                                        <h4>${{ new Intl.NumberFormat("de-DE").format(parseFloat(ingreso_local)) }}</h4>
                                    </v-col>
                                    <v-col cols="6" md="6" class="mt-n6">
                                        <h4>PROFESIONAL:</h4>
                                    </v-col>
                                    <v-col cols="6" md="6" class="mt-n6 text-end">
                                        <h4>${{ new Intl.NumberFormat("de-DE").format(parseFloat(ingreso_profesional)) }}</h4>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6" class="d-flex text-center">
                        <v-btn @click="search_atencion()" color="info" fab x-small><v-icon small>receipt</v-icon></v-btn>
                        <h6 class="mt-2 ml-2">Atención Diaria</h6>
                    </v-col>
                    <v-col cols="6" md="3">
                        <v-btn @click="clsInput()" color="teal" small rounded block dark>Limpiar</v-btn>
                    </v-col>
                    <v-col cols="6" md="3">
                        <div v-if="btn_modifica!=false">
                            <v-btn v-if="btn_venta!=true" @click="modifica_atencion()" color="teal" small rounded block dark>modificar atención</v-btn>
                            <v-btn v-else color="grey" small rounded block dark>modificar atención</v-btn>
                            <v-btn v-if="btn_venta!=true" class="mt-3" @click="eliminar_atencion()" color="error" small rounded block dark>Eliminar atención</v-btn>
                            <v-btn v-else class="mt-3" color="grey" small rounded block dark>Eliminar atención</v-btn>
                        </div>
                        <div v-else>
                            <v-btn v-if="btn_venta!=true" @click="save_atencion()" color="teal" small rounded block dark>ingresar atención</v-btn>
                            <v-btn v-else color="grey" small rounded block dark>ingresar atención</v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </div>
            <div style="height: 50px;"></div>
            <v-footer height="50" color="#c1680e" fixed></v-footer>

        <v-dialog v-model="d_proceso" persistent max-width="80%">
            <v-card color="#fff" rounded>
                <v-card-title>
                    Atención {{ date1 }}
                    <v-spacer></v-spacer>
                    <v-icon @click="d_proceso=false">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-simple-table fixed-header dense height="300" class="text-size">
                            <thead>
                                <tr>
                                    <th style="background-color: lightgrey;">N°</th>
                                    <th style="background-color: lightgrey;">Profesional</th>
                                    <th style="background-color: lightgrey;">Servicio</th>
                                    <th style="background-color: lightgrey;">($) Costo</th>
                                    <th style="background-color: lightgrey;">Cliente</th>
                                    <th style="background-color: lightgrey;">F. Pago</th>
                                    <th style="background-color: lightgrey;">($) Tarjeta</th>
                                    <th style="background-color: lightgrey;">($) Local</th>
                                    <th style="background-color: lightgrey;">($) Profesional</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in myProceso" :key="item.ID">
                                    <td><span>{{ item.Comanda }}</span></td>
                                    <td><span>{{ item.Profesional }}</span></td>
                                    <td><span>{{ item.Servicio }}</span></td>
                                    <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Total_Servicio)) }}</span></td>
                                    <td><span>{{ item.Cliente }}</span></td>
                                    <td><span>{{ item.Forma }}</span></td>
                                    <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Desc_Tarjeta)) }}</span></td>
                                    <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Ingreso_Local)) }}</span></td>
                                    <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Ingreso_Profesional)) }}</span></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="d_cliente" persistent max-width="600">
            <v-card color="#fff" rounded>
                <v-card-title>
                    Clientes
                    <v-spacer></v-spacer>
                    <v-icon @click="d_cliente=false">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <div class="hidden-sm-and-down"> <!-- Full Screen -->
                        <v-text-field v-model="search" label="Buscar" style="width: 250px;"></v-text-field>
                        <v-data-table height="300px" fixed-header @click:row="handClients" dense 
                            :search="search" :headers="titulo" :items="myClientes" 
                            :page.sync="page" :items-per-page="itemsPerPage" @page-count="pageCount = $event" 
                            hide-default-footer class="elevation-1 text-size">
                        </v-data-table>
                    </div>
                    <div class="hidden-sm-and-up"> <!-- Mobile Screen -->
                    <v-simple-table fixed-header dense height="300">
                            <thead>
                                <tr>
                                    <th style="background-color: lightgrey;">Rut</th>
                                    <th style="background-color: lightgrey;">Nombre</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr @click="handClients(item)" v-for="item in myClientes" :key="item.ID">
                                    <td><span class="text-body-2">{{ item.Rut }}</span></td>
                                    <td><span class="text-body-2">{{ item.Cliente }}</span></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="d_atencion" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-title>
                    Modificar Atención
                    <v-spacer></v-spacer>
                    <v-icon @click="close_atencion()">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <v-text-field label="N° Atención" type="number" class='text-body-2' v-model="numero" dense outlined rounded></v-text-field>
                        </v-col>
                        <v-col cols="12" class="mt-n7 text-center">
                            <v-btn @click="search_number()" color="teal" small rounded block dark>buscar número</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 11pt !important;
    height: 30px !important;
    /* background-color: lightyellow; */
}
</style>
<script>
import axios from "axios";
export default {
    name: 'Proceso',
    data: () => ({
        contrato:null,
        user:null,
        apikey:null,
        snack:false,
        color_snack:'',
        mensaje:'',
        bloqueo:null,
        loading:false,

        menu1:false,
        date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
        tipo:'',
        myTipo:['Salon','Solarium'],
        sesion:0,
        servicio:0,
        txt_servicio:'',
        myServicio:[],
        detalle:'',
        detalle_servicio:[],
        myDetalle:[],
        profesional:'',
        myProfesional:[],
        rut:'',
        cliente:'',
        myClientes:[],
        d_cliente:false,
        valor:0,
        forma:'',
        myFormaPago:[],
        comision:0,
        total_servicio:0,
        desc_tarjeta:0,
        ingreso_local:0,
        ingreso_profesional:0,
        btn_venta:false,
        d_proceso:false,
        myProceso:[],

        //modificar
        d_atencion:false,
        numero:0,
        btn_modifica:false,
        comanda:0,
        btn_atencion:false,
        search:'',
        titulo:[
          {text: 'Rut',align: 'start',sortable: true, value: 'Rut', width:'30%', class:['backgroud-color: grey ']},
          {text: 'Cliente',align: 'start',sortable: true, value: 'Cliente', width:'70%', class:['backgroud-color: grey ']},
        ],
        page: 1,
        itemsPerPage: 1000000,
        pageCount: 0,

        arrayServices:[]

    }),
    async mounted(){
        const myToken = localStorage.getItem('mytoken');
        const myUser = localStorage.getItem('myuser');
        const myContrato = localStorage.getItem('mycontrato');
        const myTime = localStorage.getItem('timeuser');
        if(myToken!=null && myUser!=null && myContrato!=null){
        //verificamos la expiracion
        const ahora = new Date();
        const expira = new Date(myTime);
        if(ahora > expira){
            this.goLogin()
        } else {
            this.apikey = myToken;
            this.contrato = myContrato;
            this.user = myUser;
            this.loading=true;
            this.bloqueo = await this.myPermiso(1);
            if(parseInt(this.bloqueo)!=0){
                await this.search_clientes();
                await this.search_services();
                await this.search_details();
                await this.search_users();
                await this.search_formas();
            }
            this.loading=false
        }
        } else {
            this.goLogin();
        }
    },
    methods:{
        change_tipo(){
            if(this.tipo=='Solarium'){
                this.sesion = 0
                //al servicio le dejamos solo el solarium
                const arrayService = this.arrayServices.filter(res => res.descripcion == 'SOLARIUM');
                if(arrayService.length!=0){
                 this.myServicio = arrayService;
                }
            } else {
                this.sesion = 1
                //al servicio le dejamos el resto de solarium
                const arrayService = this.arrayServices.filter(res => res.descripcion != 'SOLARIUM');
                if(arrayService.length!=0){
                 this.myServicio = arrayService;
                }
            };
            this.detalle='';
            this.myDetalle=[];
        },
        open_atencion(){
            this.clsInput();
            this.btn_modifica=true;
            this.d_atencion=true;
        },
        close_atencion(){
            this.clsInput();
            this.btn_modifica=false;
            this.d_atencion=false;
        },
        goLogin(){
            localStorage.removeItem('mytoken');
            localStorage.removeItem('myuser');
            localStorage.removeItem('mycontrato');
            localStorage.removeItem('timeuser');
            this.$router.push({name:'Login'})
        },
        async myPermiso(id){
            let result = 0;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : id
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    result = parseInt(datos[0].acceso);
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        clsInput(){
            this.date1 = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
            this.tipo = '';
            this.sesion = 0;
            this.servicio = 0;
            this.txt_servicio = '';
            this.detalle = '';
            this.myDetalle=[];
            this.profesional = '';
            this.rut = '';
            this.cliente = '';
            this.valor = 0;
            this.forma = '';
            this.total_servicio = 0;
            this.desc_tarjeta = 0;
            this.ingreso_local = 0;
            this.ingreso_profesional = 0;
            this.numero=0;
            this.btn_modifica=false;
            this.comanda=0;
            this.btn_atencion=false;
            this.btn_venta=false;
        },
        handClients(item){
            this.rut=item.Rut;
            this.cliente=item.Cliente;
            this.d_cliente=false
        },
        async search_clientes(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'clients' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/clients/',params,{headers});
                const datos = res.data;
                console.log('clientes',datos);
                if(datos[0].existe=='si'){
                    this.myClientes = datos;
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_services(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/services/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.myServicio.push({
                            'id': element.ID,
                            'descripcion': element.Descripcion
                        });
                    });
                    this.arrayServices = this.myServicio;
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_details(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/detail/services/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    console.log('Detail', datos);
                    datos.forEach(element => {
                        this.detalle_servicio.push({
                            'id_servicio': element.Id_Servicio,
                            'descripcion': element.Descripcion,
                            'valor': element.Costo
                        });
                    })
                }
            } catch (error) {
                console.log(error)
            };
        },
        async search_users(){
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' :  this.user,
                    'usuario' :  'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/user/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        if(element.tipo=='Profesional'){
                            this.myProfesional.push(element.usuario)
                        }
                    })
                }
            } catch (error) {
                console.log(error);
            }
        },
        change_comision(form_name){
            this.comision=0;
            this.total_servicio = 0;
            this.desc_tarjeta = 0;
            this.ingreso_local = 0;
            this.ingreso_profesional = 0;
            const found = this.myFormaPago.filter(res => res.name == form_name);
            if(found.length!=0){ this.comision = found[0].comis };
        },
        change_detail(service){
            this.myDetalle=[];
            //buscar el txt del servicio
            const found = this.myServicio.filter(res => parseInt(res.id) == parseInt(service));
            if(found.length!=0){ this.txt_servicio = found[0].descripcion };
            //filtrar el detalle del servicio por id
            const filter = this.detalle_servicio.filter(res => res.id_servicio == service);
            if(filter.length!=0){
                this.myDetalle = filter
            }
        },
        change_costo(detail){
            this.valor=0;
            const found = this.myDetalle.filter(res => res.descripcion == detail);
            if(found.length!=0){ this.valor = found[0].valor };
        },
        async search_formas(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'forma' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/type/payments/',params,{headers});
                const datos = res.data;
                console.log('forma de pago',datos);
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.myFormaPago.push({
                            'name': element.Forma,
                            'comis': element.Comision
                        })
                    });
                }
            } catch (error) {
                console.log(error)
            }
        },
        async calcular_atencion(){
            if(this.valor!=null && this.valor!=''){
                if(parseFloat(this.valor)!=0){
                    if(this.tipo=='Salon'){
                        this.total_servicio = this.valor;
                        this.desc_tarjeta = parseFloat(parseFloat(this.valor) * (parseFloat(this.comision) / 100)).toFixed(0);
                        const neto = parseFloat(this.total_servicio) - parseFloat(this.desc_tarjeta);
                        this.ingreso_local = parseFloat(parseFloat(neto) * (parseFloat(30) / 100)).toFixed(0);
                        this.ingreso_profesional = parseFloat(neto) - parseFloat(this.ingreso_local);
                    }
                    if(this.tipo=='Solarium'){
                        this.total_servicio = this.valor;
                        this.desc_tarjeta = parseFloat(parseFloat(this.valor) * (parseFloat(this.comision) / 100)).toFixed(0);
                        const neto = parseFloat(this.total_servicio) - parseFloat(this.desc_tarjeta);
                        this.ingreso_local = parseFloat(neto).toFixed(0);
                        this.ingreso_profesional = parseFloat(neto);
                    }
                } else {
                    this.color_snack='success';
                    this.mensaje='Costo de atencion incorrecto';
                    this.snack=true
                }
            } else {
                this.color_snack='success';
                this.mensaje='Costo de atencion incorrecto';
                this.snack=true
            }
        },
        async liquida_date(){
            let result = false;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'fecha': this.date1,
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/liquida/date/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    result = true
                }
            } catch (error) {
                console.log(error)
            };
            return result
        },
        async save_atencion(){
            this.loading=true;
            if(this.tipo!=null && this.tipo!='' 
                && this.comanda!=null && this.comanda!=''
                && this.sesion!=null && this.sesion!=''
                && this.servicio!=null && this.servicio!=''
                && this.profesional!=null && this.profesional!=''
                && this.valor!=null && this.valor!=''
                && this.forma!=null && this.forma!=''
                && this.rut!=null && this.rut!=''
                && this.cliente!=null && this.cliente!=''){
                if(parseFloat(this.total_servicio)!=0){
                    try {
                        //verificar si la fecha ya esta liquidada
                        const verify_date = await this.liquida_date();
                        if(verify_date){
                            this.btn_venta=true;
                            this.color_snack='error';
                            this.mensaje='La fecha ya esta liquidada';
                            this.snack=true
                        } else {
                            const headers = {
                                'Content-Type': 'application/json',
                                'Authorization': 'Token ' + this.apikey
                            };
                            const params = {
                                'contrato' : this.contrato,
                                'user' : this.user,
                                'comanda': this.comanda,
                                'fecha': this.date1,
                                'tipo': this.tipo,
                                'sesion': this.sesion,
                                'servicio': this.txt_servicio,
                                'detalle': this.detalle, // no necesitan detalle
                                'profesional': this.profesional,
                                'forma': this.forma,
                                'rut': this.rut,
                                'cliente': this.cliente,
                                'total_servicio': this.total_servicio,
                                'comision': this.comision,
                                'desc_tarjeta': this.desc_tarjeta,
                                'ingreso_local': this.ingreso_local,
                                'ingreso_profesional': this.ingreso_profesional
                            };
                            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/atencion/',params,{headers});
                            const datos = res.data;
                            console.log(datos);
                            if(datos[0].existe=='si'){
                                this.btn_venta=true;
                                this.color_snack='success';
                                this.mensaje='Atención generada con exito';
                                this.snack=true
                            }
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    this.color_snack='error';
                    this.mensaje='Debes calcular la atención';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese datos de la atención';
                this.snack=true
            };
            this.loading=false;
        },
        async search_atencion(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'desde' : this.date1,
                    'hasta' : this.date1,
                    'profesional' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/get/atencion/',params,{headers});
                const datos = res.data;
                console.log('atencion',datos);
                if(datos[0].existe=='si'){
                    this.myProceso=datos;
                    this.d_proceso=true;
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_number(){
            this.loading=true;
            if(this.numero!=null && this.numero!=''){
                if(parseInt(this.numero)!=0){
                    try {
                        const headers = {
                            'Content-Type': 'application/json',
                            'Authorization': 'Token ' + this.apikey
                        };
                        const params = {
                            'contrato' : this.contrato,
                            'user' : this.user,
                            'number' : this.numero
                        };
                        const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/number/atencion/',params,{headers});
                        const datos = res.data;
                        console.log('number atencion',datos);
                        if(datos[0].existe=='si'){
                            const element = datos[0];
                            this.btn_atencion=true;
                            this.comanda=element.Comanda; 
                            this.date1=element.Fecha;
                            this.tipo=element.Tipo;
                            this.sesion=element.Sesion;
                            this.txt_servicio=element.Servicio;
                            //obtener el id del servicio
                            const var_service = this.myServicio.filter(res => res.descripcion == this.txt_servicio);
                            if(var_service.length!=0){ 
                                this.servicio = var_service[0].id;
                                //llenamos el detalle del servicio
                                const filter = this.detalle_servicio.filter(res => parseInt(res.id_servicio) == parseInt(this.servicio));
                                if(filter.length!=0){
                                    this.myDetalle = filter                                    
                                };
                            };
                            this.detalle=element.Detalle;
                            this.valor=element.Total_Servicio;
                            this.profesional=element.Profesional;
                            this.forma=element.Forma;
                            this.rut=element.Rut;
                            this.cliente=element.Cliente;
                            this.total_servicio=element.Total_Servicio;
                            this.comision=element.Comision;
                            this.desc_tarjeta=element.Desc_Tarjeta;
                            this.ingreso_local=element.Ingreso_Local;
                            this.ingreso_profesional=element.Ingreso_Profesional;
                        } else {
                            this.color_snack='error';
                            this.mensaje='Número de atención no existe';
                            this.snack=true
                       }
                    } catch (error) {
                        console.log(error)
                    };
                    this.d_atencion=false
                } else {
                    this.color_snack='error';
                    this.mensaje='Ingrese número de atención';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese número de atención';
                this.snack=true

            };
            this.loading=false;
        },
        async modifica_atencion(){
            this.loading=true;
            if(this.tipo!=null && this.tipo!='' 
                && this.sesion!=null && this.sesion!=''
                && this.servicio!=null && this.servicio!=''
                && this.profesional!=null && this.profesional!=''
                && this.valor!=null && this.valor!=''
                && this.forma!=null && this.forma!=''
                && this.rut!=null && this.rut!=''
                && this.cliente!=null && this.cliente!=''){
                if(parseFloat(this.total_servicio)!=0 && parseFloat(this.total_servicio)==parseFloat(this.valor)){
                    //verificar si la fecha ya esta liquidada
                    const verify_date = await this.liquida_date();
                    if(verify_date){
                        this.btn_venta=true;
                        this.color_snack='error';
                        this.mensaje='La fecha ya esta liquidada';
                        this.snack=true
                    } else {
                        try {
                            const headers = {
                                'Content-Type': 'application/json',
                                'Authorization': 'Token ' + this.apikey
                            };
                            const params = {
                                'contrato' : this.contrato,
                                'user' : this.user,
                                'numero': this.numero,
                                'fecha': this.date1,
                                'tipo': this.tipo,
                                'sesion': this.sesion,
                                'servicio': this.txt_servicio,
                                'detalle': this.detalle,
                                'profesional': this.profesional,
                                'forma': this.forma,
                                'rut': this.rut,
                                'cliente': this.cliente,
                                'total_servicio': this.total_servicio,
                                'comision': this.comision,
                                'desc_tarjeta': this.desc_tarjeta,
                                'ingreso_local': this.ingreso_local,
                                'ingreso_profesional': this.ingreso_profesional
                            };
                            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/atencion/',params,{headers});
                            const datos = res.data;
                            console.log('update', datos);
                            if(datos[0].existe=='si'){
                                this.btn_venta=true;
                                this.color_snack='success';
                                this.mensaje='Atención modificada con exito';
                                this.snack=true
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    }
                } else {
                    this.color_snack='error';
                    this.mensaje='Debes calcular nuevamente la atención';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese datos de la atención';
                this.snack=true
            };
            this.loading=false;
        },
        async eliminar_atencion(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id_comanda' : this.comanda
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/delete/comanda/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    this.btn_venta=true;
                    this.color_snack='success';
                    this.mensaje='Atención eliminada con exito';
                    this.snack=true
                }                
            } catch (error) {
                console.log(error)
            }
        }


    }
}
</script>